import { Flex, Heading } from '@chakra-ui/react';
import { Component, ReactNode } from 'react';
import { errorReport } from '../../../utils/errors';
import Spinner from '../../../components/Spinner';

type Props = {
  children?: ReactNode;
};
type State = {
  hasError: boolean;
  error: any;
  visibleError: any;
};

export default class ErrorBoundary extends Component<Props, State> {
  // eslint-disable-next-line react/static-property-placement
  static defaultProps = {
    children: null,
  };

  constructor(props: { children?: ReactNode }) {
    super(props);
    this.state = { hasError: false, error: undefined, visibleError: undefined };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidUpdate(
    _prevProps: Readonly<Props>,
    prevState: Readonly<State>
  ): void {
    const { hasError, error } = this.state;
    if (
      hasError &&
      (prevState.hasError !== hasError || prevState.error !== error)
    ) {
      if (!handleLazyLoadError(error)) {
        errorReport.unknown(error);
        this.setState({ hasError, error, visibleError: error });
      }
    }
  }

  componentDidCatch(error, errorInfo) {
    errorReport.unknown(error, errorInfo);
  }

  render() {
    const { hasError, visibleError } = this.state;

    const { children } = this.props;
    if (hasError && !visibleError) {
      return (
        <Flex w="full" justifyContent="center" alignItems="center">
          <Spinner />
        </Flex>
      );
    }
    if (visibleError) {
      return (
        <Flex w="full" justifyContent="center" alignItems="center">
          <Heading fontSize="sm">Oh no!!! Something went wrong.</Heading>
        </Flex>
      );
    }
    return children;
  }
}

function handleLazyLoadError(error) {
  if (
    error instanceof Error &&
    error.message.includes('Failed to fetch dynamically imported module') &&
    error.message.includes('mooven-chunk') &&
    localStorage.getItem('refreshKey') !== error.message
  ) {
    // save file reference to localStorage to avoid infinite loop
    localStorage.setItem('refreshKey', error.message);
    errorReport.log(error);
    window.location.reload();
    return true;
  }
  return false;
}
